export default [
    '#nat#',
    'campus',
    'CF',
    'chimie',
    'cod',
    'def',
    'fanuc',
    'aquitaine',
    'manpower',
    'MDM',
    'N4S',
    'loire',
    'adour',
    'ain',
    'alsace',
    'auvergne',
    '21-71',
    'bretagne',
    'afpi-centre-val-de-loire',
    'cfai-centre-val-de-lo',
    'champagne-ardenne',
    'drome-ardeche',
    'ese',
    'territoire-de-flandre',
    'franche-comte',
    'grand-ouest-normandie',
    'etudoc-formavenir',
    'cefipa',
    'mecavenir',
    'isere',
    'afpi-limousin',
    'lorraine',
    'lyon',
    'afpi-npdc',
    'ensiame',
    'formasup-npdc',
    'poitou-charentes',
    'languedoc-roussillon',
    'paca',
    'rouen-dieppe',
    'savoie',
    'aero',
    'pn',
    'pni'
];
